import to from 'await-to-js'
import {
  ALERT_COLORS,
  MESSAGE_ERROR,
  ALERT_DELAY,
  MESSAGE_SUCCESS,
} from '@App/constantes'
import { API_URL } from '@App/configs/rest'
import Fetch from '@App/helpers/fetch'
import { setAlertBox } from '../../actions/snackbar'
import { Constants } from './types'
import { Constants as ConstantsRoles } from '@App/store/role/types'

const fetchGetOrganizationsUser = new Fetch()
const fetchCreateOrganization = new Fetch()
const fetchUpdateOrganization = new Fetch()
const fetchDeleteOrganization = new Fetch()

export interface ICreateOrUpdateOrganizationBody {
  name: string
  segments: number[]
}

export function setCurrentOrganisation(data: any[] | null) {
  return {
    type: Constants.SET_CURRENT,
    payload: data,
  }
}

export const setOrganizationsUser = (organizations: any) => {
  return {
    type: Constants.GET_ORGANIZATIONS,
    payload: organizations,
  }
}

export const setEditingOrganization = (id: Number) => {
  return {
    type: ConstantsRoles.SET_ORGANIZATION_EDIT,
    payload: id,
  }
}

export const setDeletingOrganization = (id: Number) => {
  return {
    type: ConstantsRoles.SET_ORGANIZATION_DELETE,
    payload: id,
  }
}

export const getOrganizationsUser = () => {
  return async (dispatch: any) => {
    const [err, data] = await to(
      fetchGetOrganizationsUser.get({
        url: `${API_URL}/organizations/`,
        params: {
          include: ['organization_segments'],
        },
        headers: {},
      }),
    )

    if (!err && data) {
      dispatch(setOrganizationsUser(data))

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export function createOrganization(body: ICreateOrUpdateOrganizationBody) {
  return async (dispatch: any): Promise<Error | undefined> => {
    const [err] = await to(
      fetchCreateOrganization.post({
        body,
        url: `${API_URL}/organizations/`,
        headers: {
          'content-type': 'application/json',
        },
      }),
    )
    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
    dispatch(getOrganizationsUser())
    dispatch(
      setAlertBox({
        title: MESSAGE_SUCCESS,
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }),
    )

    return
  }
}

export function updateOrganization(
  id: number,
  body: ICreateOrUpdateOrganizationBody,
) {
  return async (dispatch: any): Promise<Error | undefined> => {
    const [err] = await to(
      fetchUpdateOrganization.put({
        body,
        url: `${API_URL}/organizations/${id}`,
        headers: {
          'content-type': 'application/json',
        },
      }),
    )
    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
    dispatch(getOrganizationsUser())
    dispatch(
      setAlertBox({
        title: MESSAGE_SUCCESS,
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }),
    )

    return
  }
}

export function deleteOrganization(id: Number) {
  return async (dispatch: any): Promise<Error | undefined> => {
    const [err] = await to(
      fetchDeleteOrganization.delete({
        url: `${API_URL}/organizations/${id}`,
        params: null,
        body: {},
      }),
    )
    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }

    dispatch(getOrganizationsUser())
    dispatch(
      setAlertBox({
        title: MESSAGE_SUCCESS,
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }),
    )

    return
  }
}
